<template>
    <form class="row cSeller g-3" v-on:submit.prevent="SubmitContactSeller">
        <div class="col-md-12">
            <h1 class="pstitle" style="text-align: center">Contact Seller</h1>
        </div>
        <template v-if="this.submitSuccess">
            <div class="col-12">
                <span class="success">{{this.contactSellerSuccess}}</span>
            </div>
        </template>
        <template v-if="this.submitFailure">
            <div class="col-12">
                <span class="failure">{{this.inputFormSubmitFailure}}</span>
            </div>
        </template>
        <div class="row" v-if="!this.submitSuccess">
            <div class="col-md-12">
                <input type="text"
                    class="form-control"
                    id="fname"
                    placeholder=" "
                    v-model="v$.leadObj.firstName.$model"
                    @blur="v$.leadObj.firstName.$touch()" />
                <label for="fname" class="form-label">{{formLabel.firstName}}</label>
                <template v-if="v$.leadObj.firstName.$error">
                    <span v-for="(err, index) in v$.leadObj.firstName.$errors" :key="index" class="error text-danger validate">
                        {{ err.$message }}
                    </span>
                </template>
            </div>
            <div class="col-md-12">
                <input type="text"
                    class="form-control"
                    id="lname"
                    placeholder=" "
                    v-model="v$.leadObj.lastName.$model" 
                    @blur="v$.leadObj.lastName.$touch()"/>
                <label for="lname" class="form-label">{{formLabel.lastName}}</label>
                <template v-if="v$.leadObj.lastName.$error">
                    <span v-for="(err, index) in v$.leadObj.lastName.$errors" :key="index" class="error text-danger validate">
                        {{ err.$message }}
                    </span>
                </template>
            </div>
            <div class="col-md-12">
                <input type="email"
                    class="form-control"
                    id="email"
                    placeholder=" "
                    v-model="v$.leadObj.email.$model" 
                    @blur="v$.leadObj.email.$touch()"/>
                <label for="email" class="form-label">{{formLabel.email}}</label>
                <template v-if="v$.leadObj.email.$error">
                    <span v-for="(err, index) in v$.leadObj.email.$errors" :key="index" class="error text-danger validate">
                        {{ err.$message }}
                    </span>
                </template>
            </div>
            <div class="col-md-12">
                <input type="tel"
                    class="form-control"
                    id="phone"
                    placeholder=" "
                    v-model="leadObj.phone" />
                <label for="phone" class="form-label">{{formLabel.phone}}</label>
            </div>
            <div class="col-md-12">
                <textarea type="text"
                        class="form-control form-textarea"
                        rows="6"
                        id="message"
                        placeholder=" "
                        v-model="v$.leadObj.comments__c.$model" 
                        @blur="v$.leadObj.comments__c.$touch()"/>
                <label for="message" class="form-label">{{formLabel.message}}</label>
                <template v-if="v$.leadObj.comments__c.$error">
                    <span v-for="(err, index) in v$.leadObj.comments__c.$errors" :key="index" class="error text-danger validate">
                        {{ err.$message }}
                    </span>
                </template>
            </div>
            <div class="col-12 submission">
                <button type="submit" class="btn-submit" :disabled="isSubmitting">{{formLabel.submit}}</button>
            </div>
            <div class="hidden">
                <input type="hidden"
                    id="CONTACT_SELLER_LEAD_SOURCE"
                    name="CONTACT_SELLER_LEAD_SOURCE"
                    v-model="leadSource" />
                <input type="hidden"
                    id="loading-time"
                    name="loading-time"
                    :value="this.unixTimestamp" />
                <input type="text"
                    style="display: none"
                    id="hpValue"
                    name="hpValue"
                    v-model="hpvalue" />
            </div>
        </div>
    </form>
</template>
<script>
    import getEndPoint, { leadAPI } from "../../constants/api.config";
    import { salesforcelead } from "../../constants/form-model-config";
    import useValidate from "@vuelidate/core";
    import { required, email, helpers } from "@vuelidate/validators";
    import {inputFormSubmitFailure, contactSellerSuccess, formLabel} from '../../constants/labels.config'
    export default {
        name: "ContactSeller",
        props: {
            hin: null,
        },
        data() {
            return {
                v$: useValidate(),
                leadSource: "Contact Seller",
                hpvalue: "",
                requestTime: "",
                leadID: "",
                leadObj: { ...salesforcelead },
                submitSuccess: false,
                submitFailure: false,
                contactSellerSuccess,
                inputFormSubmitFailure,
                isSubmitting:null,
                formLabel
            };
        },
        validations() {
            return {
                leadObj:{
                    firstName: {
                        required: helpers.withMessage("First name cannot be empty", required),
                    },
                    lastName: {
                        required: helpers.withMessage("Last name cannot be empty", required),
                    },
                    email: {
                        required: helpers.withMessage(
                            "Email address cannot be empty",
                            required
                        ),
                        email: helpers.withMessage("Invalid email address", email),
                    },
                    comments__c: {
                        required: helpers.withMessage("Message cannot be empty", required),
                    },
                },                                
            };
        },
        computed: {
            unixTimestamp: function () {
                return Math.round(new Date().getTime() / 1000);
            },
        },
        methods: {
            SubmitContactSeller(e) {
                this.submitSuccess = false;
                this.submitFailure = false;
                this.isSubmitting=true;
                this.v$.$validate();
                if (this.v$.$error) {
                    this.isSubmitting=false;
                    for (var i = 0; i < this.v$.$errors.length; i++) {
                        console.log(this.v$.$errors[i].$message);
                    }
                    return;
                }                
                this.leadObj.leadSource = this.leadSource;
                this.leadObj.honeyPot = this.hpvalue;
                this.leadObj.requestTime = document.getElementById("loading-time").value;
                this.leadObj.boat_serial_number__c = this.hin;

                this.axios
                    .post(getEndPoint(leadAPI), this.leadObj)
                    .then((response) => {
                        this.leadID = response.data.id;
                        this.submitSuccess = true;
                        this.submitFailure = false;
                        this.isSubmitting = false;
                    })
                    .catch((error) => {
                        this.submitFailure = true;
                        this.submitSuccess = false;
                        this.isSubmitting = false;
                        console.error("There was an error!", error);
                    });
                e.preventDefault();
            },
        },
    };
</script>